import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  StaffFilter as StaffFilterModel,
  StaffReportServiceDetailReportBy,
  StaffReportServiceDetailRequest,
  StaffReportServiceDetailResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { ServiceDetailReportBy } from "./ServiceDetailReportBy";
import { StaffFilter } from "pages/staff/staff/StaffFilter";
import { StaffServiceFilter } from "pages/staff/staff-services/StaffServiceFilter";

export const ServiceDetailRequest = (props: {
  initialized: boolean;
  request: StaffReportServiceDetailRequest;
  setRequest: (value: StaffReportServiceDetailRequest) => void;
  globalCommonFilter: StaffFilterModel;
  setGlobalCommonFilter: (value: StaffFilterModel) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StaffReportServiceDetailResource>({});

  useEffect(() => {
    if (props.initialized) {
      ApiService.staffReports.getServiceDetailRequest().then((response) => {
        props.setRequest(response);
      });

      ApiService.staffReports.getServiceDetailResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <ServiceDetailReportBy
        reportBy={props.request.reportBy || ({} as StaffReportServiceDetailReportBy)}
        setReportBy={(reportBy) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.reportBy = reportBy;
            })
          )
        }
        resource={resource.reportBy || {}}
        validationErrors={props.validationErrors[pn<StaffReportServiceDetailRequest>("reportBy")] || {}}
      />

      <Card header="Common Filter">
        <StaffFilter
          filter={props.globalCommonFilter || ({} as StaffFilterModel)}
          setFilter={props.setGlobalCommonFilter}
        />
      </Card>

      <Card header="Service Filter">
        <StaffServiceFilter
          filter={props.request.staffServiceFilter || {}}
          setFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.staffServiceFilter = filter;
              })
            )
          }
        />
      </Card>
    </Stack>
  );
};
